import React from "react";

import { dodajAdminDogodek, preberiAdminDogodkeMeta } from "./adminGalerijaStorage.js";

const ADMIN_RACUNI = [
	{
		uporabniskoIme: "admin",
		geslo: "tunjicetunjicetunjicezupnija1",
		ime: "Administrator"
	},
	{
		uporabniskoIme: "urednik",
		geslo: "urednikTunjice2026",
		ime: "Urednik"
	},
	{
		uporabniskoIme: "galerija",
		geslo: "galerijaTunjice2026",
		ime: "Galerija"
	}
];

class Admin extends React.Component{

	constructor(props){
		super(props);

		this.prijava = this.prijava.bind(this);
		this.spremeni = this.spremeni.bind(this);
		this.spremeniSlike = this.spremeniSlike.bind(this);
		this.shrani = this.shrani.bind(this);
		this.odjava = this.odjava.bind(this);

		this.state = {
			prijavljen: window.sessionStorage.getItem("adminPrijavljen") === "1",
			uporabnik: window.sessionStorage.getItem("adminUporabnik") || "",
			uporabniskoIme: "",
			geslo: "",
			napaka: "",
			uspeh: "",
			naslov: "",
			opis: "",
			avtor: "",
			slike: [],
			shranjujem: false,
			dogodki: preberiAdminDogodkeMeta()
		};
	}

	prijava(e){
		e.preventDefault();

		const uporabniskoIme = this.state.uporabniskoIme.trim().toLowerCase();
		const racun = ADMIN_RACUNI.find(adminRacun => {
			return adminRacun.uporabniskoIme === uporabniskoIme && adminRacun.geslo === this.state.geslo;
		});

		if(racun){
			window.sessionStorage.setItem("adminPrijavljen", "1");
			window.sessionStorage.setItem("adminUporabnik", racun.ime);

			this.setState({
				prijavljen: true,
				uporabnik: racun.ime,
				uporabniskoIme: "",
				geslo: "",
				napaka: ""
			});
		}
		else{
			this.setState({
				napaka: "Napačno uporabniško ime ali geslo."
			});
		}
	}

	odjava(){
		window.sessionStorage.removeItem("adminPrijavljen");
		window.sessionStorage.removeItem("adminUporabnik");

		this.setState({
			prijavljen: false,
			uporabnik: "",
			uporabniskoIme: "",
			geslo: "",
			napaka: "",
			uspeh: ""
		});
	}

	spremeni(e){
		this.setState({
			[e.target.name]: e.target.value,
			napaka: "",
			uspeh: ""
		});
	}

	spremeniSlike(e){
		this.setState({
			slike: Array.from(e.target.files || []),
			napaka: "",
			uspeh: ""
		});
	}

	async shrani(e){
		e.preventDefault();

		if(this.state.naslov.trim().length === 0){
			this.setState({ napaka: "Vpišite naslov dogodka." });
			return;
		}

		if(this.state.slike.length === 0){
			this.setState({ napaka: "Izberite vsaj eno sliko." });
			return;
		}

		this.setState({
			shranjujem: true,
			napaka: "",
			uspeh: ""
		});

		try{
			await dodajAdminDogodek({
				naslov: this.state.naslov,
				opis: this.state.opis,
				avtor: this.state.avtor,
				dodal: this.state.uporabnik,
				slike: this.state.slike
			});

			this.setState({
				naslov: "",
				opis: "",
				avtor: "",
				slike: [],
				shranjujem: false,
				uspeh: "Dogodek je dodan v galerijo.",
				dogodki: preberiAdminDogodkeMeta()
			});

			if(this.refs.slike){
				this.refs.slike.value = "";
			}
		}
		catch(error){
			this.setState({
				shranjujem: false,
				napaka: "Shranjevanje ni uspelo. Poskusite z manjšimi slikami."
			});
		}
	}

	render(){
		if(!this.state.prijavljen){
			return(
				<div className = "admin-stran">
					<div className = "admin-okvir">
						<h1 className = "naslovi">Admin</h1>
						<form onSubmit = {this.prijava}>
							<label>Uporabniško ime</label>
							<input
								type = "text"
								className = "form-control"
								value = {this.state.uporabniskoIme}
								onChange = {(e) => this.setState({ uporabniskoIme: e.target.value, napaka: "" })}
								autoComplete = "username"
							/>

							<label>Geslo</label>
							<input
								type = "password"
								className = "form-control"
								value = {this.state.geslo}
								onChange = {(e) => this.setState({ geslo: e.target.value, napaka: "" })}
								autoComplete = "current-password"
							/>
							{this.state.napaka ? <p className = "admin-napaka">{this.state.napaka}</p> : null}
							<button className = "btn btn-default btn-lg admin-gumb" type = "submit">Prijava</button>
						</form>
					</div>
				</div>
			);
		}

		return(
			<div className = "admin-stran">
				<div className = "admin-okvir">
					<div className = "row mar0">
						<div className = "col-xs-12 col-sm-8 pad0">
							<h1 className = "naslovi">Admin galerija</h1>
						</div>
						<div className = "col-xs-12 col-sm-4 text-right pad0 admin-domov">
							<a className = "btn btn-default" href = "/#galerija">Galerija</a>
							<button className = "btn btn-default admin-odjava" type = "button" onClick = {this.odjava}>Odjava</button>
						</div>
					</div>
					<p className = "admin-opomba">Prijavljen: {this.state.uporabnik}</p>

					<form onSubmit = {this.shrani} className = "admin-obrazec">
						<label>Naslov dogodka</label>
						<input
							name = "naslov"
							className = "form-control"
							value = {this.state.naslov}
							onChange = {this.spremeni}
							placeholder = "npr. Oratorij 2026"
						/>

						<label>Opis</label>
						<textarea
							name = "opis"
							className = "form-control"
							value = {this.state.opis}
							onChange = {this.spremeni}
							rows = "4"
						/>

						<label>Fotograf</label>
						<input
							name = "avtor"
							className = "form-control"
							value = {this.state.avtor}
							onChange = {this.spremeni}
							placeholder = "npr. Fotograf: Ime Priimek"
						/>

						<label>Slike dogodka</label>
						<input
							ref = "slike"
							type = "file"
							className = "form-control"
							accept = "image/*"
							multiple
							onChange = {this.spremeniSlike}
						/>

						{this.state.slike.length > 0 ? (
							<p className = "admin-opomba">Izbranih slik: {this.state.slike.length}</p>
						) : null}

						{this.state.napaka ? <p className = "admin-napaka">{this.state.napaka}</p> : null}
						{this.state.uspeh ? <p className = "admin-uspeh">{this.state.uspeh}</p> : null}

						<button className = "btn btn-default btn-lg admin-gumb" type = "submit" disabled = {this.state.shranjujem}>
							{this.state.shranjujem ? "Shranjujem ..." : "Dodaj dogodek"}
						</button>
					</form>

					<div className = "admin-seznam">
						<h2 className = "naslovi">Dodani dogodki</h2>
						{this.state.dogodki.length === 0 ? (
							<p>Ni še dodanih dogodkov.</p>
						) : (
							this.state.dogodki.map(dogodek => (
								<div className = "admin-dogodek" key = {dogodek.id}>
									<strong>{dogodek.naslov}</strong>
									<span>{dogodek.slike.length} slik{dogodek.dodal ? " | " + dogodek.dodal : ""}</span>
								</div>
							))
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default Admin;
